export default "__VITE_ASSET__7379dd5a__"